"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wwgCostMeritsIconMapping = exports.wwgCostMeritOptions = exports.wwgCostMerits = exports.skillupCostMeritsIconMapping = exports.skillUpCostsMeritOptions = exports.skillUpCostMerits = void 0;
var map_1 = __importDefault(require("lodash/map"));
exports.skillUpCostMerits = [
    'Free based on need',
    'Free for everyone',
    'Pays you',
    'Financial aid available',
    'Zero-interest loans available',
    'Accepts Federal student aid',
    'Accepts WIOA funding',
    'Income share agreement',
];
exports.skillUpCostsMeritOptions = (0, map_1.default)(exports.skillUpCostMerits, function (merit) {
    return {
        value: merit,
        label: merit,
    };
});
exports.skillupCostMeritsIconMapping = {
    'Free based on need': 'https://res.cloudinary.com/wherewego/image/upload/v1652976604/WWG2000%20Site%20Photos/blt4vfg4ex6cuszxkdgb.svg',
    'Free for everyone': 'https://res.cloudinary.com/wherewego/image/upload/v1652976631/WWG2000%20Site%20Photos/fcrfl3jrn708byhvehin.svg',
    'Pays you': 'https://res.cloudinary.com/wherewego/image/upload/v1652976604/WWG2000%20Site%20Photos/blt4vfg4ex6cuszxkdgb.svg',
    'Financial aid available': 'https://res.cloudinary.com/wherewego/image/upload/v1652996963/WWG2000%20Site%20Photos/dim9bfnbp5qqqkg1alec.svg',
    'Zero-interest loans available': 'https://res.cloudinary.com/wherewego/image/upload/v1652976604/WWG2000%20Site%20Photos/blt4vfg4ex6cuszxkdgb.svg',
    'Accepts Federal student aid': 'https://res.cloudinary.com/wherewego/image/upload/v1652997177/WWG2000%20Site%20Photos/lsdq8igzvuucn3hug90a.svg',
    'Accepts WIOA funding': 'https://res.cloudinary.com/wherewego/image/upload/v1652976793/WWG2000%20Site%20Photos/kculofv402fhx7eofudd.svg',
    'Income share agreement': 'https://res.cloudinary.com/wherewego/image/upload/v1652976818/WWG2000%20Site%20Photos/gvymyes8cpxnlspzpl5t.svg',
};
exports.wwgCostMerits = [
    'Scholarships available',
    'Income share agreement',
    'No upfront costs',
    'Free for everyone',
    'Free depending on need',
    'Accepts WIOA funding',
    'Accepts Federal financial aid',
    'Fully covered by Pell Grant',
    'Pays you',
];
exports.wwgCostMeritOptions = (0, map_1.default)(exports.wwgCostMerits, function (merit) {
    return {
        value: merit,
        label: merit,
    };
});
exports.wwgCostMeritsIconMapping = {
    'Scholarships available': 'https://res.cloudinary.com/wherewego/image/upload/v1649344950/WWG2000%20Site%20Photos/d7iaf3yw2pytilo1bszi.svg',
    'Free for everyone': 'https://res.cloudinary.com/wherewego/image/upload/v1649343454/WWG2000%20Site%20Photos/qtxfiksjq3rhkuw2dk3e.svg',
    'Free depending on need': 'https://res.cloudinary.com/wherewego/image/upload/v1649344950/WWG2000%20Site%20Photos/levzv08idlwwb9p5xggs.svg',
    'Accepts Federal financial aid': 'https://res.cloudinary.com/wherewego/image/upload/v1649344950/WWG2000%20Site%20Photos/kkos8mgciu0qo7fiff0q.svg',
    'Income share agreement': 'https://res.cloudinary.com/wherewego/image/upload/v1649343454/WWG2000%20Site%20Photos/v0epg5swdsmphq9v53vv.svg',
    'No upfront costs': 'https://res.cloudinary.com/wherewego/image/upload/v1649343454/WWG2000%20Site%20Photos/qtxfiksjq3rhkuw2dk3e.svg',
    'Fully covered by Pell Grant': 'https://res.cloudinary.com/wherewego/image/upload/v1649344950/WWG2000%20Site%20Photos/yfe62nqvbvozptqysans.svg',
    'Accepts WIOA funding': 'https://res.cloudinary.com/wherewego/image/upload/v1649344950/WWG2000%20Site%20Photos/yfe62nqvbvozptqysans.svg',
    'Pays you': 'https://res.cloudinary.com/wherewego/image/upload/v1649344950/WWG2000%20Site%20Photos/levzv08idlwwb9p5xggs.svg',
};
